<template>
  <v-layout class="map-container" fill-height v-resize="resizeMap">    
      <map-control :uiid="uiid" />
      <fleet-map :uiid="uiid" ref="map" />                   
  </v-layout>
</template>
<script>
import FleetMap from '@/components/map/FleetMap'
import MapControl from '@/components/map/MapControl'
  export default {
    name: 'GlobalFleet',   
    components:{FleetMap,MapControl}, 
    props:{
      uiid:{
          type: String,
          default: 'map_global'
      }
    },
    mounted() {          
      setTimeout(() => this.resizeMap(),2000)
    },
    methods: {           
      resizeMap(){                
        if(this.$refs.map) this.$refs.map.updateSize()        
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.map-container{
  position: absolute;
  top: 0; bottom: 0; left: 0; right: 0;
}
</style>
